import type { Locale } from '@seek/melways-sites';

export const formatRating = (rating: number, decimal = 0) =>
  rating.toFixed(decimal);

export const formatCount = (rating: number, locale: Locale): string => {
  // For compact notation (like 1.4K)
  if (rating >= 1000) {
    return new Intl.NumberFormat(locale, {
      notation: 'compact',
      compactDisplay: 'short',
    }).format(rating);
  }

  // For regular numbers
  return rating.toString();
};
